import { Translation } from 'src/types';
import { SiteGatewayZonePricingPlan } from 'src/features/pricing/sites/utils/types';

export enum REQUIRED_IDENTIFIER_TYPES {
    LICENSE_PLATE = 'license_plate',
    TICKET = 'ticket',
    ACCESS_KEY = 'access_key',
}

export type Gateway = {
    id: string;
    translations: {
        id: string;
        created_at: string;
        modified_at: string;
        language: string;
        name: string;
        description: string;
    }[];
    created_at: string;
    modified_at: string;
    required_identifier_types: REQUIRED_IDENTIFIER_TYPES[];
    entry_zone: {
        id: string;
        translations: Translation[];
    };
    exit_zone: {
        id: string;
        translations: Translation[];
    };
    allow_unknown_main_identifier: boolean;
    require_all_identifier: boolean;
};

export interface GatewayPricingPlan extends SiteGatewayZonePricingPlan {
    gateway?: string;
    gateway_translations?: {
        language: string;
        name: string;
    }[];
}
